function roundCurrency(value) {
  return Math.round(((Number(value) || 0) + Number.EPSILON) * 100) / 100;
}

export function serializeTradeDraftCardForRequest(card = {}) {
  return {
    id: card.id || null,
    source_listing_id: card.source_listing_id ? Number(card.source_listing_id) : (card.id ? Number(card.id) : null),
    printing_id: card.printing_id ? Number(card.printing_id) : null,
    card: card.card || "Unknown card",
    edition: card.edition || null,
    language: card.language || null,
    condition: card.condition || null,
    foil: Boolean(card.foil),
    altered: Boolean(card.altered),
    signed: Boolean(card.signed),
    rarity: card.rarity || null,
    collector_number: card.collector_number || null,
    scryfall_id: card.scryfall_id || card.scryfallId || null,
    image: card.image || null,
    qty: Math.max(1, Number(card.qty) || 1),
    user_price: roundCurrency(card.user_price),
    line_total: roundCurrency((Number(card.line_total) || ((Number(card.qty) || 1) * (Number(card.user_price) || 0)))),
    variant_group_key: card.variant_group_key || null
  };
}

export function getTradeDraftRequestCardKey(card = {}) {
  const serializedCard = serializeTradeDraftCardForRequest(card);
  const listingId = Number(serializedCard.source_listing_id || serializedCard.id);

  if (Number.isInteger(listingId) && listingId > 0) {
    return `listing:${listingId}`;
  }

  return [
    serializedCard.printing_id || "",
    String(serializedCard.language || "").trim().toLowerCase(),
    String(serializedCard.condition || "").trim().toUpperCase(),
    serializedCard.foil ? "foil" : "nonfoil",
    serializedCard.altered ? "altered" : "clean",
    serializedCard.signed ? "signed" : "unsigned",
    String(serializedCard.card || "").trim().toLowerCase()
  ].join(":");
}

export function mergeTradeDraftRequestCards(...cardCollections) {
  const cardsByKey = new Map();

  cardCollections.flat().forEach((card) => {
    const serializedCard = serializeTradeDraftCardForRequest(card);
    const key = getTradeDraftRequestCardKey(serializedCard);

    if (!key || cardsByKey.has(key)) {
      return;
    }

    cardsByKey.set(key, serializedCard);
  });

  return [...cardsByKey.values()];
}

export function getRequestedTradeDraftQty(cards = [], card = {}) {
  const key = getTradeDraftRequestCardKey(card);
  const mergedCards = mergeTradeDraftRequestCards(cards);
  const existingCard = mergedCards.find((candidate) => getTradeDraftRequestCardKey(candidate) === key);

  return existingCard ? Math.max(1, Number(existingCard.qty) || 1) : 0;
}

export function addTradeDraftRequestCard(cards = [], card = {}, qtyToAdd = 1) {
  const normalizedCards = mergeTradeDraftRequestCards(cards);
  const serializedCard = serializeTradeDraftCardForRequest({
    ...card,
    qty: Math.max(1, Number(qtyToAdd) || 1)
  });
  const key = getTradeDraftRequestCardKey(serializedCard);
  const existingIndex = normalizedCards.findIndex((candidate) => getTradeDraftRequestCardKey(candidate) === key);

  if (existingIndex < 0) {
    return [...normalizedCards, serializedCard];
  }

  const existingCard = normalizedCards[existingIndex];
  const nextQty = Math.max(1, Number(existingCard.qty) || 1) + Math.max(1, Number(serializedCard.qty) || 1);
  const unitPrice = roundCurrency(existingCard.user_price || serializedCard.user_price);
  const nextCard = {
    ...existingCard,
    qty: nextQty,
    line_total: roundCurrency(nextQty * unitPrice),
    variant_group_key: existingCard.variant_group_key || serializedCard.variant_group_key || null
  };

  return normalizedCards.map((candidate, index) => (index === existingIndex ? nextCard : candidate));
}